import React from 'react'
import { isEqual } from 'lodash'
import { useSetState } from 'react-use'
import { isProductionHost } from 'lib/env'

export const DebugToolsContext = React.createContext()

const useActions = (setState, state) => {
    // define actions
    const actions = {
        setDebugObjectsInfo: () => null,
    }

    // dev env actions
    if (!isProductionHost()) {
        actions.setDebugObjectsInfo = (origin, objectsInfo) => {
            if (isEqual(state.objectsInfo, objectsInfo) && isEqual(state.objectsInfoOrigin, origin)) return

            // add one frame timeout to avoid react warning:
            // Warning: Cannot update a component (`DebugTools`) while rendering a different component (`Context.Consumer`). To locate the bad setState() call inside `Context.Consumer`
            setTimeout(() => (
                setState({
                    objectsInfoOrigin: origin,
                    objectsInfo: objectsInfo,
                })
            ), 0)
        }
    }

    return actions
}

const DebugTools = ({ children }) => {
    const [state, setState] = useSetState({
        objectsInfoOrigin: null,
        objectsInfo: null,
    })
    const actions = useActions(setState, state)

    return (
        <DebugToolsContext.Provider
            value={{
                ...actions,
                ...state,
            }}
        >
            {children}
        </DebugToolsContext.Provider>
    )
}

export default DebugTools
